module.exports = __webpack_public_path__ + "static/Pipe Dream Extreme.d9d774e5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/feature-graphics/Pipe Dream Extreme.jpg
// module id = 472
// module chunks = 35783957827783